import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M145-146q-32 0-56-23-23-24-23-56v-510q0-33 23-56 24-24 56-24h670q33 0 56 24 24 23 24 56v510q0 32-24 56-23 23-56 23H145Zm0-79h670v-510H145v510Zm0 0v-510 510Zm144-54h383q22 0 37-16 15-15 15-37t-15-37q-15-15-37-15H288q-22 0-37 15t-15 37q0 22 15 37 16 16 38 16Z"/>',
  f: '<path d="M145-146q-32 0-56-23-23-24-23-56v-510q0-33 23-56 24-24 56-24h670q33 0 56 24 24 23 24 56v510q0 32-24 56-23 23-56 23H145Zm144-133h383q22 0 37-16t15-37q0-22-15-37t-37-15H288q-22 0-37 15t-15 37q0 22 16 37t37 16Z"/>',
};

export default data;
